// The server names each notification item in English; its type says which
// it is, so the bell and the dashboard read in the app's language. An
// unknown type keeps the server's words.
export function itemTitle(t, item) {
  return t(`notifications.types.${item.type}`, { defaultValue: item.title });
}

export function itemDetail(t, item) {
  if (item.type === "compliance_gap") {
    return item.critical_count ? t("notifications.detail.critical", { count: item.critical_count }) : "";
  }
  if (item.type === "webhook_failure") return t("notifications.detail.last24h");
  if (item.type === "doc_overdue") return t("notifications.detail.over7Days");
  return item.detail || "";
}
